import styled, { css } from 'styled-components'

export const Wrapper = styled.span`
  .dynamicButtons {
    margin-left: auto;
    width: fit-content;
    margin-bottom: 1.25rem;
  }
`
